import src from "IMAGE";
export default { src, width: 1267, height: 198, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADk5OfYUFBSeHx8f1BsbG7QfHx+4JSUl1Q8PD5wcHBz2k3IJHlBmaEYAAAAASUVORK5CYII="};
